import * as React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { BarChart } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import theme from "../../theme";

interface NoDataOverlayProps {
  message1: string;
  message2?: string;
}
const NoDataOverlay: React.FC<NoDataOverlayProps> = ({
  message1,
  message2,
}: NoDataOverlayProps) => {
  return (
    <Grid
      container
      item
      direction={"column"}
      alignItems={"center"}
      alignContent={"center"}
      justifyContent={"center"}
    >
      <Grid item>
        <BarChart
          sx={{
            width: "50px",
            height: "50px",
            color: theme.palette.gray.light,
          }}
        />
      </Grid>
      <Grid item>
        <IgTypography>{message1}</IgTypography>
      </Grid>
      <Grid item>
        <IgTypography>{message2}</IgTypography>
      </Grid>
    </Grid>
  );
};

export default NoDataOverlay;
